//
import { required } from "@/services/validations"
import ProductModel from "@/models/Warehouse/WhProduct"

//
import ProductFilters from "@/views/Warehouse/WhProduct/list/filters"
import ProductHeaders from "@/views/Warehouse/WhProduct/list/headers"
import ProviderBranchOfficesHeaders from "./headers"

//
export default ({ pch_provider_id }) => [
    {
        title: "general",
        fields: [
            {
                name: "rut",
                type: "text-field",
                flex: {
                    sm6: true,
                    lg4: true,
                },
                props: {
                    label: "Rut",
                    readonly: true,
                },
            },
            {
                name: "business_name",
                type: "text-field",
                flex: {
                    sm6: true,
                    lg4: true,
                },
                props: {
                    label: "Razón social",
                    readonly: true,
                },
            },
            {
                name: "alias_name",
                type: "text-field",
                flex: {
                    sm6: true,
                    lg4: true,
                },
                props: {
                    label: "Alias",
                    readonly: true,
                },
            },
            {
                name: "branch_offices",
                type: "data-table-model",
                flex: {
                    "pt-0": true,
                    xs12: true,
                },
                props: {
                    class: "v-card elevation-2 mb-4",
                    headers: ProviderBranchOfficesHeaders,
                    noActions: true,
                    noDataText: "Sin sucursales.",
                    noFilter: true,
                    noExport: true,
                    noHelper: true,
                    noPagination: true,
                    noSearch: true,
                    showNativePagination: true,
                    toolbarTitle: "Lista de sucursales del proveedor",
                    toolbarColor: "primary",
                    toolbarDark: true,
                    toolbarDense: true,
                    rules: [ required ],
                },
            },
        ]
    },
    {
        title: "catalogo",
        fields: [
            {
                name: "_",
                type: "data-table-model",
                flex: {
                    "pt-0": true,
                    xs12: true,
                },
                props: {
                    class: "v-card elevation-2 mb-4",
                    filters: ProductFilters,
                    headers: ProductHeaders,
                    label: "Items",
                    noActions: true,
                    noDataText: "Sin productos.",
                    noFilter: true,
                    noSearch: true,
                    paramFilter: {
                        pch_provider_id,
                    },
                    service: ProductModel,
                    toolbarTitle: "Lista de productos del proveedor",
                    toolbarColor: "primary",
                    toolbarDark: true,
                    toolbarDense: true,
                },
            },
        ]
    }    
]